export default {"src":"/_next/static/media/training.d8661635.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};